var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiquality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 12",
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.888 1.702l-.03.028A5.924 5.924 0 00.08 5.046c-.052.308-.078.62-.079.93v.036c0 .3.025.598.072.894.148.923.522 1.82 1.122 2.612.198.261.42.511.668.747l.026.025a6.211 6.211 0 001.772 1.173c2.342 1.026 5.194.55 7.327-1.16a.496.496 0 01.017-.013c2.408-1.941 4.618-3.7 6.996-3.7s4.588 1.759 6.996 3.7a7.842 7.842 0 002.13 1.224c.988.376 2.031.538 3.05.47a6.28 6.28 0 003.936-1.694l.026-.025c.248-.236.47-.486.669-.747.6-.792.973-1.689 1.12-2.612a5.754 5.754 0 00-.006-1.86 5.926 5.926 0 00-1.78-3.316l-.03-.028C32.996.65 31.61.106 30.177.014a7.323 7.323 0 00-3.053.474 7.93 7.93 0 00-2.127 1.214c-2.417 1.93-4.606 3.7-6.996 3.7-2.39 0-4.579-1.77-6.996-3.7l-.013-.01C9.606.592 7.917 0 6.261 0c-.895 0-1.78.173-2.603.531a6.168 6.168 0 00-1.77 1.171z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(41.2215 0 0 21.0874 -.869 3.328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#1CE5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#5440D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#8B2CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#D421EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC39FD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquality);
export default __webpack_public_path__ + "static/media/liquality.da8ca51cd5eb6477ee3d14c73855a00d.svg";
export { ForwardRef as ReactComponent };